import { Button, Card, CardContent, Grid, IconButton, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
export const ProyectoCard = (data) => {

    // Global
    const navigate = useNavigate();
    // Función para convertir minutos en formato hh:mm
    const formatTime = (totalMinutes) => {
        if (totalMinutes === null || totalMinutes === undefined) return ""; // Si no hay minutos, devuelve vacío
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    };
    return (
        <>
            <Grid item xs={12} sm={6} md={4} lg={3} >
                <Card
                    onClick={() => navigate("/proyecto/" + data.data.id)}
                    className="menu-card"
                    style={{ cursor: 'pointer', transition: '0.3s', borderRadius: 15, boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.4)',  background: "var(--fondoTarjeta)" }}
                >
                    <CardContent style={{ textAlign: 'center', padding: '30px' }}>
                        <IconButton color='primary'>
                            <FolderSpecialIcon />

                        </IconButton>
                        <Typography variant="h6" component="div">
                            {data.data.nombre.toUpperCase()}
                        </Typography>
                        <Typography variant="h6" component="div">
                            {formatTime(data.data.total_minutos) +"H"}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
        </>
    )
}
